import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "train-details" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-8" }
const _hoisted_4 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_5 = { class: "mb-0 caption" }
const _hoisted_6 = { class: "caption-strong" }
const _hoisted_7 = {
  key: 1,
  class: "mb-1"
}
const _hoisted_8 = { class: "mb-0 caption" }
const _hoisted_9 = { class: "caption-strong" }
const _hoisted_10 = { class: "mb-0 caption" }
const _hoisted_11 = { class: "col-4 d-flex align-items-start justify-content-center" }
const _hoisted_12 = ["src", "alt"]

import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { getTrainStationName, getTrainCompanyName } from '@/utils/locationCodes'

  // Initialize i18n
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TrainDetails',
  props: {
    tripInformation: {}
  },
  setup(__props: any) {

      const { t } = useI18n()
  
  

  

  


  // Define the props
  const props = __props

  // Get train details object
  const trainDetail = computed(() => {
    if (Array.isArray(props.tripInformation) && props.tripInformation.length > 0) {
      // Check for the correct structure: tripInformation[0].details
      return props.tripInformation[0].details || props.tripInformation[0].tripInformation
    }
    return props.tripInformation
  })

  // Get outbound train information
  const outboundTrain = computed(() => {
    const train = trainDetail.value
    if (train?.outboundTrip) {
      const departureStation = getTrainStationName(train.outboundTrip.departure?.location || '')
      const arrivalStation = getTrainStationName(train.outboundTrip.arrival?.location || '')
      const departureDate = train.outboundTrip.departure?.date || ''
      const departureTime = train.outboundTrip.departure?.time || ''
      const arrivalDate = train.outboundTrip.arrival?.date || ''
      const arrivalTime = train.outboundTrip.arrival?.time || ''
      const operatorCode = getTrainCompanyName(train.outboundTrip.company || '')
      return {
        departureStation,
        arrivalStation,
        departureDate,
        departureTime,
        arrivalDate,
        arrivalTime,
        operatorCode
      }
    }
    return null
  })

  // Get inbound train information
  const inboundTrain = computed(() => {
    const train = trainDetail.value
    if (train?.inboundTrip) {
      const departureStation = getTrainStationName(train.inboundTrip.departure?.location || '')
      const arrivalStation = getTrainStationName(train.inboundTrip.arrival?.location || '')
      const departureDate = train.inboundTrip.departure?.date || ''
      const departureTime = train.inboundTrip.departure?.time || ''
      const arrivalDate = train.inboundTrip.arrival?.date || ''
      const arrivalTime = train.inboundTrip.arrival?.time || ''
      const operatorCode = getTrainCompanyName(train.inboundTrip.company || '')
      return {
        departureStation,
        arrivalStation,
        departureDate,
        departureTime,
        arrivalDate,
        arrivalTime,
        operatorCode
      }
    }
    return null
  })

  // Handle image loading errors
  const handleImageError = (event: Event) => {
    const img = event.target as HTMLImageElement
    img.style.display = 'none' // Hide the image if it fails to load
  }

  // Helper function to get the primary train operator code (prefer outbound, fallback to inbound)
  const getPrimaryTrainOperator = (): string => {
    const outboundOperator = outboundTrain.value?.operatorCode
    const inboundOperator = inboundTrain.value?.operatorCode
    return outboundOperator || inboundOperator || ''
  }

  // Train company image mapping
  const trainImages: Record<string, string> = {
    'Eurostar': require('@/assets/carrier-logos/Eurostar.png'),
    '9F': require('@/assets/carrier-logos/Eurostar.png'),
    // Add more train company logos as needed
  }

  // Helper function to get train operator icon URL
  const getTrainOperatorIconUrl = (operatorCode: string): string => {
    return trainImages[operatorCode] || ''
  }

  // Helper function to format date as DD/MM/YY
  const formatDate = (dateString: string): string => {
    if (!dateString) return ''
    const date = new Date(dateString)
    const day = date.getDate().toString().padStart(2, '0')
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const year = date.getFullYear().toString().slice(-2)
    return `${day}/${month}/${year}`
  }

  // Map train class names to display names
  const formatTrainClass = (trainClass: string): string => {
    const classMap: Record<string, string> = {
      'Premium': 'Première',
      'Standart': 'Standard',
      'Standard': 'Standard',
      'Economy': 'Standard',
      'Eco': 'Standard',
      'First': 'Première',
      'Business': 'Première'
    }
    return classMap[trainClass] || trainClass
  }

  // Helper function to get train class
  const getTrainClass = () => {
    const train = trainDetail.value
    
    let rawClass = ''
    if (train?.class) {
      rawClass = train.class
    } else if (train?.outboundTrip?.class) {
      rawClass = train.outboundTrip.class
    } else if (train?.inboundTrip?.class) {
      rawClass = train.inboundTrip.class
    } else {
      rawClass = 'Standard'
    }
    
    return formatTrainClass(rawClass)
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (outboundTrain.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('reservations.outbound')), 1),
                _createTextVNode(" " + _toDisplayString(formatDate(outboundTrain.value.departureDate)) + " " + _toDisplayString(outboundTrain.value.departureStation) + " " + _toDisplayString(outboundTrain.value.departureTime) + " → " + _toDisplayString(outboundTrain.value.arrivalStation) + " " + _toDisplayString(outboundTrain.value.arrivalTime), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (inboundTrain.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('reservations.return')), 1),
                _createTextVNode(" " + _toDisplayString(formatDate(inboundTrain.value.departureDate)) + " " + _toDisplayString(inboundTrain.value.departureStation) + " " + _toDisplayString(inboundTrain.value.departureTime) + " → " + _toDisplayString(inboundTrain.value.arrivalStation) + " " + _toDisplayString(inboundTrain.value.arrivalTime), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_10, _toDisplayString(getTrainClass()) + " " + _toDisplayString(_unref(t)('reservations.class')), 1)
      ]),
      _createElementVNode("div", _hoisted_11, [
        (getPrimaryTrainOperator())
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: getTrainOperatorIconUrl(getPrimaryTrainOperator()),
              alt: `${getPrimaryTrainOperator()} logo`,
              class: "train-operator-logo",
              onError: handleImageError
            }, null, 40, _hoisted_12))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})